import React, { useState } from 'react'
import { Button } from 'semantic-ui-react'
import TwoWayQuerybuilder from 'react-two-way-querybuilder'
import { AppContext } from './../../../providers'

const fields = [
  { name: 'firstName', operators: 'all', label: 'First Name', input: { type: 'text' } },
  { name: 'lastName', operators: 'all', label: 'Last Name', input: { type: 'text' } },
  { name: 'age', operators: 'all', label: 'Age', input: { type: 'text' } },
  { name: 'birthDate', operators: 'all', label: 'Birth date', input: { type: 'text' } },
]

const styles = {
  primaryBtn: 'ui mini button',
  deleteBtn: 'ui mini grey button',
  rule: 'qRule',
  condition: 'qCondition',
  select: 'qSelect',
  input: 'qInput',
  txtArea: 'qTextarea',
}

const changedStyles = {
  styles,
}

const DisplayConditions = ({ close, save }) => {
  const [displayconditions, setDisplayconditions] = useState({})
  const { theme } = React.useContext(AppContext)

  const onChangeDisplayConditions = (event) => {
    const formatted = `{{# if ${event.query} }}`
    setDisplayconditions(formatted)
  }

  const onHandleSave = () => {
    const results = {
      type: 'Demo Display Condition',
      label: 'Demo Condition',
      description: 'Made with my builder',
      before: displayconditions,
      after: '{{/if}}',
    }
    save(results)
  }

  const onHandleClose = () => {
    close()
  }

  return (
    <>
      <div id="builder">
        <TwoWayQuerybuilder
          fields={fields}
          onChange={onChangeDisplayConditions}
          config={changedStyles}
        />
      </div>

      <div
        className="actions"
        style={{ width: '100%', textAlign: 'right', marginTop: '5px' }}
      >

        <Button color={theme.button.secondary} onClick={onHandleSave}>
          <i className="save icon"></i> Save
          </Button>

        <Button onClick={onHandleClose}>
          <i className="close icon"></i> Cancel
          </Button>

      </div>
    </>
  )
}

export default DisplayConditions
